export const career = {
	lookingFor: {
		title: 'We are hiring',
		content:
			'We are looking for an independent colleague for our team, who has a technical mindset and a pleasant ' +
			'demeanor. Authorization is not a condition. If you meet the requirements, write to us at ' +
			'<a href="mailto: pareli@pareli.sk">pareli@pareli.sk</a> and we can talk more at a personal interview.',
	},
	activities: {
		title: 'Our activities',
		content:
			'We are aware that project designing is a demanding activity and there are times when you just have to ' +
			'"turn off". That\'s why we offer a MultiSport card to every single one of our colleagues. We also ' +
			'organize football matches, paintball games, corporate stays and dinners.',
	},
};
